import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import SplashText from '../buttonApp/SplashText';
import ToggleSwitch from '../ToggleSwitch';
import { Tooltip } from 'react-tooltip';

import UseToast from '../../UseToast';
import SlidePanelForm from '../buttonApp/SlidePanelForm';
import Button from '../buttonApp/Button';
import { MuiColorInput } from 'mui-color-input';
import LanguageSelector from '../buttonApp/LanguageSelector';
import useFontFamilies from '../../../hooks/useFontFamilies';

export default function TriviaQuizMenu() {
  const fontOptions = useFontFamilies('option');
  const [submenuNames, setSubmenuNames] = useState({}); // Object to track submenu names
  const [menus, setMenus] = useState([]);
  const { userId } = useParams(); // Get the optional client ID from the route
  const { showMsgSuccessToast, showErrorToast } = UseToast(); // Use the custom hook
  const navigate = useNavigate();
  const isEffectRan = useRef(false); // Track if useEffect has run

  // Language support
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [loadingLanguages, setLoadingLanguages] = useState(false);

  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [heightoffset, setHeightOffset] = useState(0);
  const [leftoffset, setLeftOffset] = useState(0);

  const [rightOffset, setRightOffset] = useState(0);

  const [openButtonId, setOpenButtonId] = useState(null); // Track which button is open

  const handleSave = async config => {
    try {
      const response = await axios.post('/api/topic-main-settings', { ...config, userId: userId });
      console.log('Data saved:', response.data);
    } catch (error) {
      console.error('Error saving settings:', error);
    }
  };

  // States for four different files
  const [correctResponse, setCorrectResponse] = useState(null);
  const [correctResponseGif, setCorrectResponseGif] = useState(null);

  const [wrongResponse, setWrongResponse] = useState(null);
  const [wrongResponseGif, setWrongResponseGif] = useState(null);

  const [promoPageVideo, setPromoPageVideo] = useState(null);
  const [promoPageCenterLogo, setPromoPageCenterLogo] = useState(null);
  const [promoPageCenterBelowLogo, setPromoPageCenterBelowLogo] = useState(null);
  const [resultBackMedia, setResultBackMedia] = useState(null);

  const [questionTimerVideo, setQuestionTimerVideo] = useState(null);

  const [buttonColor, setButtonColor] = useState('');

  const [frontendmainmenu, setFrontMainMenus] = useState([]);
  const [frontMainmenuName, setFrontMainMenuName] = useState([null]);

  const [leftTopMedia, setLeftTopMedia] = useState(null);
  const [leftBottomMedia, setLeftBottomMedia] = useState(null);
  const [rightTopMedia, setRightTopMedia] = useState(null);
  const [rightBottomMedia, setRightBottomMedia] = useState(null);

  const [leftTopMediaTopic, setLeftTopMediaTopic] = useState(null);
  const [leftBottomMediaTopic, setLeftBottomMediaTopic] = useState(null);
  const [rightTopMediaTopic, setRightTopMediaTopic] = useState(null);
  const [rightBottomMediaTopic, setRightBottomMediaTopic] = useState(null);

  const [centerBelowMenuMedia, setCenterBelowMenuMedia] = useState(null);
  const [centerLogoMedia, setCenterLogoMedia] = useState(null);
  const [backMenuMedia, setBackMenuMedia] = useState(null);

  const [resultToPromo, setResultToPromo] = useState(10);

  const [clickSound, setClickSound] = useState(null);

  const [clickSoundVolume, setClickSoundVolume] = useState(1);

  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const [topicFontSize, setTopicFontSize] = useState(66);
  const [topicLineHeight, setTopicLineHeight] = useState(0.6);
  const [topicPadding, setTopicPadding] = useState(20);

  const [quizFontSize, setQuizFontSize] = useState(66);
  const [quizLineHeight, setQuizLineHeight] = useState(0.6);
  const [quizPadding, setQuizPadding] = useState(20);

  const [uploadingStates, setUploadingStates] = useState({
    correctResponse: false,
    correctResponseGif: false,
    wrongResponse: false,
    wrongResponseGif: false,
    promoPageVideo: false,
    promoPageCenterLogo: false,
    promoPageCenterBelowLogo: false,
    questionTimerVideo: false,
    leftTop: false,
    leftBottom: false,
    rightTop: false,
    rightBottom: false,

    leftTopMediaTopic: false,
    leftBottomMediaTopic: false,
    rightTopMediaTopic: false,
    rightBottomMediaTopic: false,
    centerBelowMenuMedia: false,
    centerLogoMedia: false,
    backMenuMedia: false,
    resultBackMedia: false,
    clickSound: false,
  });
  const [uploadedUrls, setUploadedUrls] = useState({
    leftTop: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    leftBottom: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    rightTop: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    rightBottom: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    correctResponse: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
    correctResponseGif: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
    wrongResponse: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
    wrongResponseGif: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
    promoPageVideo: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
    promoPageCenterLogo: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    promoPageCenterBelowLogo: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    questionTimerVideo: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },

    leftTopMediaTopic: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    leftBottomMediaTopic: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    rightTopMediaTopic: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    rightBottomMediaTopic: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    centerBelowMenuMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    centerLogoMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    backMenuMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
      width: 0,
      height: 0,
    },
    resultBackMedia: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
    clickSound: {
      fileName: '',
      fileUrl: '',
      enabled: false,
    },
  });

  const [settings, setSettings] = useState({
    globalSettings: {
      cornerRadius: 0,
      height: 50,
      width: 150,
      outlineColor: '#000000',
      outlineThickness: 1,
      fillColor: '#ffffff',
      font: 'Arial',
      fontColor: '#127E10',
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: '#FF5733', // Bright orange
      },
      highlight: {
        borderColor: '#000000',
        fillColor: '#ffffff',
        fontColor: '#000000',
      },
      clickSound: '',
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: 'center',
      marginBottom: 2,
      lineHeight: 1,
      padding: 10,
    },
  });

  const [answerSettings, setAnswerSettings] = useState({
    answerSettings: {
      cornerRadius: 0,
      height: 50,
      width: 150,
      outlineColor: '#000000',
      outlineThickness: 1,
      fillColor: '#ffffff',
      font: 'Arial',
      fontColor: '#127E10',
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: '#FF5733', // Bright orange
      },
      highlight: {
        borderColor: '#000000',
        fillColor: '#ffffff',
        fontColor: '#000000',
      },
      clickSound: '',
      clickSoundFilename: null,
      clickSoundVolume: 1,
      textAlign: 'center',
      marginBottom: 2,
    },
  });

  const [questionTextSettings, setQuestionTextSettings] = useState({
    questionTextSettings: {
      height: 50,
      width: 100,
      font: 'Arial',
      fontColor: '#127E10',
      fontSize: 16,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: '#FF5733', // Bright orange
      },
      highlight: {
        fontColor: '#000',
      },
      textAlign: 'center',
    },

    enabled: false,
  });

  useEffect(() => {
    if (userId && !isEffectRan.current) {
      isEffectRan.current = true; // Mark as ran

      // Load available languages first, then load data
      fetchAvailableLanguages();
    }
  }, [userId]);

  const fetchAvailableLanguages = async () => {
    setLoadingLanguages(true);
    try {
      const response = await axios.get(`/api/language/${userId}`);
      if (response.data.success) {
        setAvailableLanguages(response.data.languages);
        
        // Check for saved language preference
        const savedLang = localStorage.getItem(`trivia_language_pref_${userId}`);
        if (savedLang && response.data.languages.includes(savedLang)) {
          setCurrentLanguage(savedLang);
          // Load data with saved language
          runTriviaApi(savedLang);
        } else {
          // Default to first language or 'en'
          setCurrentLanguage(response.data.languages[0] || 'en');
          runTriviaApi(response.data.languages[0] || 'en');
        }
      }
    } catch (error) {
      console.error('Error fetching languages:', error);
      setAvailableLanguages(['en']);
      setCurrentLanguage('en');
      runTriviaApi('en');
    } finally {
      setLoadingLanguages(false);
    }
  };

  const runTriviaApi = async (lang = "en") => {
    try {
      const response = await axios.get(`/api/trivia-topics-menu/${userId}/${lang}`);
      if (response.data.error) {
        showErrorToast('No Trivia Quiz Topic Found');
        setButtonColor(response.data?.site_brand_color);
      } else {
        const filterMenus = response.data?.data.triviaquizmenu || [];
        setFrontMainMenus(filterMenus);
        setButtonColor(response.data?.site_brand_color);
      }
    } catch (error) {
      console.error('Error fetching trivia menus:', error);
    }
  };

  // Function to change language
  const handleLanguageChange = async (langCode) => {
    setCurrentLanguage(langCode);
    
    // Save preference to localStorage
    localStorage.setItem(`trivia_language_pref_${userId}`, langCode);
    
    // Fetch data with new language
    await runTriviaApi(langCode);
    
    // Fetch media data for new language
    await fetchMedia(userId, langCode);
    
    // Show success message
    showMsgSuccessToast(`Language changed to ${getLanguageName(langCode)}`);
  };

  const createFrontMainMenu = () => {
    if (!frontMainmenuName.trim()) return; // Prevent empty menu creation
    axios
      .post('/api/add-trivia-topics-menu', { 
        name: frontMainmenuName, 
        userId: userId,
        currentLanguage: currentLanguage 
      })
      .then(response => {
        if (!response.data.error) {
          runTriviaApi(currentLanguage);
          setFrontMainMenuName('');
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  // Toggle menu visibility
  const toggleMenuVisibility = (topicId, isVisible) => {
    axios
      .post(`/api/trivia-topic-visibility`, {
        userId: userId,
        topicId: topicId,
        isVisible: !isVisible,
      })
      .then(response => {
        runTriviaApi(currentLanguage);
      });
  };

  const deleteMenu = topicId => {
    axios
      .post(`/api/delete-trivia-topic`, { topicId, userId: userId })
      .then(() => {
        runTriviaApi(currentLanguage);
      })
      .catch(error => {
        console.error('Error deleting menu:', error);
      });
  };

  // Content Upload

  useEffect(() => {
    if (currentLanguage) {
      fetchMedia(userId, currentLanguage);
    }
  }, [userId, currentLanguage]);

  const fetchMedia = async (id, language = currentLanguage) => {
    try {
      // Make an API call to get media data for the user with specified language
      const response = await axios.get(`/api/topic-main-settings/${id}/${language}`);
      const mediaData = response.data; // Access the first object in the array

      console.log('🔍 Fetching media for language:', language);
      console.log('📦 Full mediaData received:', mediaData);
      console.log('🎨 globalSettings:', mediaData?.globalSettings);
      console.log('📁 leftTopMediaTopic:', mediaData?.leftTopMediaTopic);

      // Update the state with the retrieved media data
      setUploadedUrls(prevUrls => ({
        ...prevUrls, // Preserve previous data
        correctResponse: {
          fileName: mediaData?.correctResponse?.fileName || '',
          fileUrl: mediaData?.correctResponse?.fileUrl || '',
          enabled: mediaData?.correctResponse?.enabled || false,
        },
        correctResponseGif: {
          fileName: mediaData?.correctResponseGif?.fileName || '',
          fileUrl: mediaData?.correctResponseGif?.fileUrl || '',
          enabled: mediaData?.correctResponseGif?.enabled || false,
        },
        wrongResponse: {
          fileName: mediaData?.wrongResponse?.fileName || '',
          fileUrl: mediaData?.wrongResponse?.fileUrl || '',
          enabled: mediaData?.wrongResponse?.enabled || false,
        },
        wrongResponseGif: {
          fileName: mediaData?.wrongResponseGif?.fileName || '',
          fileUrl: mediaData?.wrongResponseGif?.fileUrl || '',
          enabled: mediaData?.wrongResponseGif?.enabled || false,
        },
        promoPageVideo: {
          fileName: mediaData?.promoPageVideo?.fileName || '',
          fileUrl: mediaData?.promoPageVideo?.fileUrl || '',
          enabled: mediaData?.promoPageVideo?.enabled || false,
        },
        promoPageCenterLogo: {
          fileName: mediaData?.promoPageCenterLogo?.fileName || '',
          fileUrl: mediaData?.promoPageCenterLogo?.fileUrl || '',
          enabled: mediaData?.promoPageCenterLogo?.enabled || false,
        },
        promoPageCenterBelowLogo: {
          fileName: mediaData?.promoPageCenterBelowLogo?.fileName || '',
          fileUrl: mediaData?.promoPageCenterBelowLogo?.fileUrl || '',
          enabled: mediaData?.promoPageCenterBelowLogo?.enabled || false,
        },
        questionTimerVideo: {
          fileName: mediaData?.questionTimerVideo?.fileName || '',
          fileUrl: mediaData?.questionTimerVideo?.fileUrl || '',
          enabled: mediaData?.questionTimerVideo?.enabled || false,
        },
        leftTop: {
          fileName: mediaData?.leftTop?.fileName || '',
          fileUrl: mediaData?.leftTop?.fileUrl || '',
          enabled: mediaData?.leftTop?.enabled || false,
        },
        leftBottom: {
          fileName: mediaData?.leftBottom?.fileName || '',
          fileUrl: mediaData?.leftBottom?.fileUrl || '',
          enabled: mediaData?.leftBottom?.enabled || false,
        },
        rightTop: {
          fileName: mediaData?.rightTop?.fileName || '',
          fileUrl: mediaData?.rightTop?.fileUrl || '',
          enabled: mediaData?.rightTop?.enabled || false,
        },
        rightBottom: {
          fileName: mediaData?.rightBottom?.fileName || '',
          fileUrl: mediaData?.rightBottom?.fileUrl || '',
          enabled: mediaData?.rightBottom?.enabled || false,
        },

        leftTopMediaTopic: {
          fileName: mediaData?.leftTopMediaTopic?.fileName || '',
          fileUrl: mediaData?.leftTopMediaTopic?.fileUrl || '',
          enabled: mediaData?.leftTopMediaTopic?.enabled || false,
        },
        leftBottomMediaTopic: {
          fileName: mediaData?.leftBottomMediaTopic?.fileName || '',
          fileUrl: mediaData?.leftBottomMediaTopic?.fileUrl || '',
          enabled: mediaData?.leftBottomMediaTopic?.enabled || false,
        },
        rightTopMediaTopic: {
          fileName: mediaData?.rightTopMediaTopic?.fileName || '',
          fileUrl: mediaData?.rightTopMediaTopic?.fileUrl || '',
          enabled: mediaData?.rightTopMediaTopic?.enabled || false,
        },
        rightBottomMediaTopic: {
          fileName: mediaData?.rightBottomMediaTopic?.fileName || '',
          fileUrl: mediaData?.rightBottomMediaTopic?.fileUrl || '',
          enabled: mediaData?.rightBottomMediaTopic?.enabled || false,
        },
        centerBelowMenuMedia: {
          fileName: mediaData?.centerBelowMenuMedia?.fileName || '',
          fileUrl: mediaData?.centerBelowMenuMedia?.fileUrl || '',
          enabled: mediaData?.centerBelowMenuMedia?.enabled || false,
        },
        centerLogoMedia: {
          fileName: mediaData?.centerLogoMedia?.fileName || '',
          fileUrl: mediaData?.centerLogoMedia?.fileUrl || '',
          enabled: mediaData?.centerLogoMedia?.enabled || false,
        },
        backMenuMedia: {
          fileName: mediaData?.backMenuMedia?.fileName || '',
          fileUrl: mediaData?.backMenuMedia?.fileUrl || '',
          enabled: mediaData?.backMenuMedia?.enabled || false,
          width: mediaData?.backMenuMedia?.width || 0,
          height: mediaData?.backMenuMedia?.height || 0,
        },
        resultBackMedia: {
          fileName: mediaData?.resultBackMedia?.fileName || '',
          fileUrl: mediaData?.resultBackMedia?.fileUrl || '',
          enabled: mediaData?.resultBackMedia?.enabled || false,
        },
        clickSound: {
          fileName: mediaData?.clickSound?.fileName || '',
          fileUrl: mediaData?.clickSound?.fileUrl || '',
          enabled: mediaData?.clickSound?.enabled || false,
        },
      }));

      console.log('✅ State updated with media data');

      setSettings(prevSettings => ({
        ...prevSettings,
        globalSettings: {
          ...prevSettings?.globalSettings,
          ...mediaData?.globalSettings, // Merge globalSettings as well
        },
      }));

      setAnswerSettings(prevSettings => ({
        ...prevSettings,
        answerSettings: {
          ...prevSettings?.answerSettings,
          ...mediaData?.answerSettings, // Merge globalSettings as well
        },
      }));

      setQuestionTextSettings(prevSettings => ({
        ...prevSettings,
        questionTextSettings: {
          ...prevSettings?.questionTextSettings,
          ...mediaData?.questionTextSettings, // Merge globalSettings as well
        },
      }));

      setHeightOffset(mediaData?.quizsetting?.heightoffset);
      setLeftOffset(mediaData?.quizsetting?.leftoffset);
      setRightOffset(mediaData?.quizsetting?.rightoffset);
      setResultToPromo(mediaData?.resultToPromo);
      setClickSoundVolume(mediaData?.clickSoundVolume);

      setTopicFontSize(mediaData?.topicFontSize);
      setTopicLineHeight(mediaData?.topicLineHeight);
      setTopicPadding(mediaData?.topicPadding);

      setQuizFontSize(mediaData?.quizFontSize);
      setQuizLineHeight(mediaData?.quizLineHeight);
      setQuizPadding(mediaData?.quizPadding);
    } catch (error) {
      console.error('❌ Failed to fetch media data:', error);
    }
  };

  // Drop handlers for different media
  const createDropHandler = setMedia => acceptedFiles => {
    if (acceptedFiles.length > 0) {
      setMedia(acceptedFiles[0]);
    }
  };

  // Common upload handler
  const handleUpload = async (file, position) => {
    if (!file) {
      showErrorToast(`Please select a file for ${position} first!`);
      return;
    }

    // Set the specific position to uploading
    setUploadingStates(prev => ({ ...prev, [position]: true }));

    try {
      // Step 1: Get Pre-signed URL from the Backend
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

      // Step 2: Upload the File to S3
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      // Step 3: Save Uploaded File Information
      const fileUrl = url.split('?')[0];

      setUploadedUrls(prev => ({
        ...prev,
        [position]: {
          fileName: file.name, // Store file name
          fileUrl: fileUrl, // Store file URL
        },
      }));
      setUploadingStates(prev => ({ ...prev, [position]: false }));

      setUploadedUrls(prevState => ({
        ...prevState,
        [position]: {
          ...prevState[position],
          enabled: true,
        },
      }));
    } catch (error) {
      console.error('Upload failed:', error);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    settings.userId = userId;
    try {
      await axios.post('/api/save-topic-settings', {
        userId: userId,
        language: currentLanguage, // Add current language
        mediaData: uploadedUrls,
        globalSettings: settings?.globalSettings,
        answerSettings: answerSettings?.answerSettings,
        questionTextSettings: questionTextSettings?.questionTextSettings,
        leftoffset: leftoffset,
        rightOffset: rightOffset,
        heightoffset: heightoffset,
        resultToPromo: resultToPromo,
        clickSoundVolume: clickSoundVolume,
        topicFontSize: topicFontSize,
        topicLineHeight: topicLineHeight,
        topicPadding: topicPadding,
        quizFontSize: quizFontSize,
        quizLineHeight: quizLineHeight,
        quizPadding: quizPadding,
      });

      showMsgSuccessToast('Settings Save Successfully!');
    } catch (error) {
      console.error('Failed to save media data:', error);
      showErrorToast('Error saving media data!');
    }
  };

  const handleChange = (key, value) => {
    // Determine whether to update global or custom settings
    const basePath = 'globalSettings';
    const fullPath = `${basePath}.${key}`;
    const keys = fullPath.split('.'); // Split the path into parts
    const newSettings = { ...settings };

    keys.reduce((obj, currentKey, index) => {
      if (index === keys.length - 1) {
        // If it's the last key, update the value
        obj[currentKey] = value;
      } else {
        // Otherwise, ensure the object exists before traversing
        obj[currentKey] = { ...obj[currentKey] };
      }
      return obj[currentKey];
    }, newSettings);

    setSettings(newSettings);
  };

  const handleAnswerChange = (key, value) => {
    // Determine whether to update global or custom settings
    const basePath = 'answerSettings';
    const fullPath = `${basePath}.${key}`;
    const keys = fullPath.split('.'); // Split the path into parts
    const newSettings = { ...answerSettings };

    keys.reduce((obj, currentKey, index) => {
      if (index === keys.length - 1) {
        // If it's the last key, update the value
        obj[currentKey] = value;
      } else {
        // Otherwise, ensure the object exists before traversing
        obj[currentKey] = { ...obj[currentKey] };
      }
      return obj[currentKey];
    }, newSettings);

    setAnswerSettings(newSettings);
  };

  const handleQuestionTextChange = (key, value) => {
    // Determine whether to update global or custom settings
    const basePath = 'questionTextSettings';
    const fullPath = `${basePath}.${key}`;
    const keys = fullPath.split('.'); // Split the path into parts
    const newSettings = { ...questionTextSettings };

    keys.reduce((obj, currentKey, index) => {
      if (index === keys.length - 1) {
        // If it's the last key, update the value
        obj[currentKey] = value;
      } else {
        // Otherwise, ensure the object exists before traversing
        obj[currentKey] = { ...obj[currentKey] };
      }
      return obj[currentKey];
    }, newSettings);

    setQuestionTextSettings(newSettings);
  };

  const handleToggleChangeMedia = (mediaKey, on) => {
    setUploadedUrls(prevState => ({
      ...prevState,
      [mediaKey]: {
        ...prevState[mediaKey],
        enabled: on,
      },
    }));
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };
  function adjustHeights() {
    const menuCards = document.querySelectorAll('.submenu-list');

    let maxHeight = 0;

    // Reset all card heights first (important for dynamic resizing)
    menuCards.forEach(card => {
      card.style.minHeight = 'auto';
    });

    // Find the tallest box
    menuCards.forEach(card => {
      maxHeight = Math.max(maxHeight, card.offsetHeight);
    });

    // Apply the tallest height to all cards
    menuCards.forEach(card => {
      card.style.minHeight = `${maxHeight}px`;
    });
  }

  useEffect(() => {
    // Adjust heights on initial render
    adjustHeights();

    // Adjust heights on window resize
    window.addEventListener('resize', adjustHeights);

    return () => {
      window.removeEventListener('resize', adjustHeights);
    };
  }, [submenuNames, menus, value]);

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px">
          <div className="page-header">
            <div className="row">
              {/* <div className="col-md-6 col-sm-12">
                        <div className="title">
                            <h4>Main Menu</h4>
                        </div>
                    </div> */}

              <div className="col-md-6 col-sm-12">
                <div className="title">
                  <h4>Trivia Quiz</h4>
                </div>
              </div>

              <div className="col-md-6 col-sm-12" style={{ width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>
                  {/* Language Selector */}
                  {!loadingLanguages && availableLanguages.length > 1 && (
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          borderColor: buttonColor,
                          color: buttonColor
                        }}
                      >
                        <span 
                          className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                          style={{ fontSize: '16px' }}
                        ></span>
                        <span className="me-1">{getLanguageName(currentLanguage)}</span>
                        <span className="badge bg-primary ms-1" style={{ backgroundColor: buttonColor }}>
                          {availableLanguages.length}
                        </span>
                      </button>
                      <ul className="dropdown-menu">
                        {availableLanguages.map(lang => (
                          <li key={lang}>
                            <button
                              className={`dropdown-item d-flex align-items-center ${currentLanguage === lang ? 'active' : ''}`}
                              type="button"
                              onClick={() => handleLanguageChange(lang)}
                              style={{
                                backgroundColor: currentLanguage === lang ? `${buttonColor}20` : 'transparent'
                              }}
                            >
                              <span 
                                className={`fi fi-${getLanguageFlag(lang)} me-2`}
                                style={{ fontSize: '16px' }}
                              ></span>
                              <span>{getLanguageName(lang)}</span>
                              {currentLanguage === lang && (
                                <i className="fas fa-check ms-auto text-success"></i>
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {!loadingLanguages && availableLanguages.length === 1 && (
                    <div className="d-flex align-items-center text-muted">
                      <span 
                        className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                        style={{ fontSize: '16px' }}
                      ></span>
                      <span>{getLanguageName(currentLanguage)}</span>
                      <small className="ms-2">(Only language available)</small>
                    </div>
                  )}

                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{ backgroundColor: buttonColor }}
                    className="btn btn-success"
                  >
                    {`<< Go Back`}
                  </button>
                </div>
                {/* <span className="bi bi-gear micon" style={{color:buttonColor}} onClick={() => setIsPanelOpen(!isPanelOpen)}> Menu Buttons Configuration</span> */}

                {/* Side Panel */}
                <SlidePanelForm
                  isOpen={isPanelOpen}
                  onClose={() => setIsPanelOpen(false)}
                  onSave={handleSave}
                  buttonColor={{ buttonColor }}
                  userId={userId}
                  title="Trivia Topics Settings"
                />
              </div>
            </div>
          </div>
          <div className="dashboard-container">
            <Box sx={{ width: '100%' }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label="tab navigation"
                sx={{
                  '& .MuiTab-root': { minWidth: 100 }, // Ensures consistent width
                  '& .Mui-selected': { fontWeight: 'bold' }, // Active tab styling
                }}
              >
                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Trivia Topics"
                />
                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Topic Page Settings"
                />
                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Quiz Page Settings"
                />
                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Quiz Topics Button Styling"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Question Answers Styling"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Question Text Styling"
                />

                <Tab
                  sx={{
                    '&:hover': {
                      backgroundColor: buttonColor, // Add your desired hover color here
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                  }}
                  label="Language Management"
                />
              </Tabs>
              <Box sx={{ p: 3 }}>
                {value === 0 && (
                  <>
                    <div
                      className="center-container"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '35px',
                      }}
                    >
                      <div className="menu-card" style={{ marginRight: '15px' }}>
                        <div className="menu-title">
                          <span>{'Trivia Topics'}</span>

                          <Link
                            to={`#`}
                            onClick={() => {
                              setIsPanelOpen(!isPanelOpen);
                              setOpenButtonId(null);
                            }}
                          >
                            {' '}
                            <span className="bi bi-gear micon"></span>
                          </Link>
                        </div>

                        {/* Render Submenus */}
                        <ul className="submenu-list" style={{ minHeight: '119px' }}>
                          {(frontendmainmenu || []).map(submenu => (
                            <li className="submenu-item" key={submenu._id}>
                              {/* {submenu.name}{" "} */}
                              {/* {truncateText(submenu.name, 20)} */}

                              <span
                                data-tooltip-id={`tooltip-${submenu._id}`}
                                data-tooltip-content={submenu.name.length > 20 ? submenu.name : ''}
                              >
                                {truncateText(submenu.name, 20)} {submenu?.matchedMenuName}
                              </span>
                              {/* <ReactTooltip id={`submenu-${submenu._id}`} place="top" effect="solid" /> */}

                              <Tooltip
                                id={`tooltip-${submenu._id}`}
                                place="top"
                                style={{ backgroundColor: buttonColor, zIndex: 9999 }}
                                effect="float"
                              />

                              <div>
                                {submenu.isVisible ? (
                                  <span
                                    className="bi bi-eye micon"
                                    onClick={() =>
                                      toggleMenuVisibility(submenu._id, submenu.isVisible, true)
                                    }
                                  ></span>
                                ) : (
                                  <span
                                    className="bi bi-eye-slash micon"
                                    onClick={() =>
                                      toggleMenuVisibility(submenu._id, submenu.isVisible, true)
                                    }
                                  ></span>
                                )}

                                <Link to={`/questions-bank/${userId}/${submenu._id}`}>
                                  <span className="bi bi-gear micon"></span>
                                </Link>

                                <span
                                  className="bi bi-trash micon"
                                  onClick={() => {
                                    if (
                                      window.confirm('Are you sure you want to delete this button?')
                                    ) {
                                      deleteMenu(submenu._id, true);
                                    }
                                  }}
                                ></span>
                              </div>
                            </li>
                          ))}
                        </ul>

                        {/* Add Submenu */}
                        <div className="form-group" style={{ display: 'flex' }}>
                          <input
                            type="text"
                            placeholder="Enter Topic Name"
                            value={frontMainmenuName}
                            onChange={e => setFrontMainMenuName(e.target.value)}
                          />
                          <button
                            style={{ backgroundColor: buttonColor }}
                            className="add-btn"
                            onClick={createFrontMainMenu}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Button Menu */}
                  </>
                )}

                {value === 1 && (
                  <div>
                    <form
                      className="tab-wizard wizard-circle wizard vertical"
                      onSubmit={handleSubmit}
                    >
                      <div className="row ">
                        {/* Left Top Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.leftTopMediaTopic?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Left Top Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.leftTopMediaTopic.enabled}
                              id={'leftTopMediaTopic'}
                              onChange={value =>
                                handleToggleChangeMedia('leftTopMediaTopic', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setLeftTopMediaTopic)}
                              selectedFile={leftTopMediaTopic}
                            />

                            <UploadButton
                              uploading={uploadingStates.leftTopMediaTopic}
                              onUpload={() => handleUpload(leftTopMediaTopic, 'leftTopMediaTopic')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.leftTopMediaTopic} />
                          </div>
                        </div>

                        {/* Right Top Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.rightTopMediaTopic?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Right Top Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.rightTopMediaTopic.enabled}
                              onChange={val => handleToggleChangeMedia('rightTopMediaTopic', val)}
                              id={'rightTopMediaTopic'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setRightTopMediaTopic)}
                              selectedFile={rightTopMediaTopic}
                            />
                            <UploadButton
                              uploading={uploadingStates.rightTopMediaTopic}
                              onUpload={() =>
                                handleUpload(rightTopMediaTopic, 'rightTopMediaTopic')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.rightTopMediaTopic} />
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        {/* Left Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.leftBottomMediaTopic?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Left Bottom Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.leftBottomMediaTopic.enabled}
                              id={'leftBottomMediaTopic'}
                              onChange={value =>
                                handleToggleChangeMedia('leftBottomMediaTopic', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setLeftBottomMediaTopic)}
                              selectedFile={leftBottomMediaTopic}
                            />
                            <UploadButton
                              uploading={uploadingStates.leftBottomMediaTopic}
                              onUpload={() =>
                                handleUpload(leftBottomMediaTopic, 'leftBottomMediaTopic')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.leftBottomMediaTopic} />
                          </div>
                        </div>

                        {/* Right Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.rightBottomMediaTopic?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Right Bottom Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.rightBottomMediaTopic.enabled}
                              onChange={val =>
                                handleToggleChangeMedia('rightBottomMediaTopic', val)
                              }
                              id={'rightBottomMediaTopic'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setRightBottomMediaTopic)}
                              selectedFile={rightBottomMediaTopic}
                            />
                            <UploadButton
                              uploading={uploadingStates.rightBottomMediaTopic}
                              onUpload={() =>
                                handleUpload(rightBottomMediaTopic, 'rightBottomMediaTopic')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.rightBottomMediaTopic} />
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        {/* Left Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.centerBelowMenuMedia?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Center Below Topic Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.centerBelowMenuMedia.enabled}
                              id={'centerBelowMenuMedia'}
                              onChange={value =>
                                handleToggleChangeMedia('centerBelowMenuMedia', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setCenterBelowMenuMedia)}
                              selectedFile={centerBelowMenuMedia}
                            />
                            <UploadButton
                              uploading={uploadingStates.centerBelowMenuMedia}
                              onUpload={() =>
                                handleUpload(centerBelowMenuMedia, 'centerBelowMenuMedia')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.centerBelowMenuMedia} />
                          </div>
                        </div>

                        {/* Right Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.centerLogoMedia?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Center Logo Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.centerLogoMedia.enabled}
                              onChange={val => handleToggleChangeMedia('centerLogoMedia', val)}
                              id={'centerLogoMedia'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setCenterLogoMedia)}
                              selectedFile={centerLogoMedia}
                            />
                            <UploadButton
                              uploading={uploadingStates.centerLogoMedia}
                              onUpload={() => handleUpload(centerLogoMedia, 'centerLogoMedia')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.centerLogoMedia} />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.backMenuMedia?.enabled ? 'disabled' : ''} h-100 w-100
                            `}
                            style={{
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            gap: '5px',
                          }}
                          >
                            <div className="form-group">
                            <label>Back Menu Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.backMenuMedia.enabled}
                              id={'backMenuMedia'}
                              onChange={value => handleToggleChangeMedia('backMenuMedia', value)}
                            />
                            </div>
                            
                            <MediaDropzone
                              onDrop={createDropHandler(setBackMenuMedia)}
                              selectedFile={backMenuMedia}
                            />
                            <UploadedUrl url={uploadedUrls.backMenuMedia} />
                            
                              <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >

                            <UploadButton
                              uploading={uploadingStates.backMenuMedia}
                              onUpload={() => handleUpload(backMenuMedia, 'backMenuMedia')}
                              buttonColor={buttonColor}
                            />
                              <div
                              style={{
                                // flex: '1',
                                display: 'flex',
                                justifyContent: 'end',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  width: '60%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  height: '100%',
                                }}
                              >
                                <label style={{ fontWeight: '600', whiteSpace: 'nowrap', margin: '0' }}>
                                  Size (%):
                                </label>

                                <input
                                  style={{ width: '100%', height: '100%' }}
                                  type="number"
                                  value={uploadedUrls.backMenuMedia.width}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      backMenuMedia: {
                                        ...uploadedUrls.backMenuMedia,
                                        width: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </div>

                              <label style={{ display: 'none' }}>
                                Height:
                                <input
                                  type="number"
                                  value={uploadedUrls.backMenuMedia.height}
                                  onChange={e =>
                                    setUploadedUrls({
                                      ...uploadedUrls,
                                      backMenuMedia: {
                                        ...uploadedUrls.backMenuMedia,
                                        height: Number(e.target.value),
                                      },
                                    })
                                  }
                                />
                              </label>
                            </div>

                            </div>
                            
                          </div>
                        </div>

                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.clickSound?.enabled ? 'disabled' : ''} h-100 w-100`}
                          >
                            <label>Topic Click Sound:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.clickSound.enabled}
                              id={'clickSound'}
                              onChange={value => handleToggleChangeMedia('clickSound', value)}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setClickSound)}
                              selectedFile={clickSound}
                            />

                            <UploadButton
                              uploading={uploadingStates.clickSound}
                              onUpload={() => handleUpload(clickSound, 'clickSound')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.clickSound} />
                          </div>
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: '15px' }}>
                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>
                              Click sound volume{' '}
                              <strong>(The volume range should be 0 to 1)</strong>:
                            </label>
                            <input
                              type="number"
                              value={clickSoundVolume}
                              min="0"
                              max="1"
                              step="0.1"
                              onChange={e => {
                                let value = Number(e.target.value);
                                if (value < 0) value = 0;
                                if (value > 1) value = 1;
                                setClickSoundVolume(Number(value));
                              }}
                              //onChange={(e) => setClickSoundVolume(Number(e.target.value))}
                              placeholder="Click Sound volume"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Topic Page Popup Font lineHeight</label>
                            <input
                              type="number"
                              value={topicLineHeight}
                              onChange={e => setTopicLineHeight(Number(e.target.value))}
                              placeholder="Topic Page Popup Font lineHeight"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Topic Page Popup Font Size In Px</label>
                            <input
                              type="number"
                              value={topicFontSize}
                              onChange={e => setTopicFontSize(Number(e.target.value))}
                              placeholder="Topic Page Popup Font Size In Px"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Topic Page Popup Padding In Px</label>
                            <input
                              type="number"
                              value={topicPadding}
                              onChange={e => setTopicPadding(Number(e.target.value))}
                              placeholder="Topic Page Popup Padding In Px"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <button
                            style={{ backgroundColor: buttonColor }}
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}

                {value === 2 && (
                  <div>
                    <form
                      className="tab-wizard wizard-circle wizard vertical"
                      onSubmit={handleSubmit}
                    >
                      <div className="row ">
                        {/* Left Top Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.leftTop?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Left Top Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.leftTop.enabled}
                              id={'leftTop'}
                              onChange={value => handleToggleChangeMedia('leftTop', value)}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setLeftTopMedia)}
                              selectedFile={leftTopMedia}
                            />

                            <UploadButton
                              uploading={uploadingStates.leftTop}
                              onUpload={() => handleUpload(leftTopMedia, 'leftTop')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.leftTop} />
                          </div>
                        </div>

                        {/* Right Top Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.rightTop?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Right Top Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.rightTop.enabled}
                              onChange={val => handleToggleChangeMedia('rightTop', val)}
                              id={'rightTop'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setRightTopMedia)}
                              selectedFile={rightTopMedia}
                            />
                            <UploadButton
                              uploading={uploadingStates.rightTop}
                              onUpload={() => handleUpload(rightTopMedia, 'rightTop')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.rightTop} />
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        {/* Left Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.leftBottom?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Left Bottom Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.leftBottom.enabled}
                              id={'leftBottom'}
                              onChange={value => handleToggleChangeMedia('leftBottom', value)}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setLeftBottomMedia)}
                              selectedFile={leftBottomMedia}
                            />
                            <UploadButton
                              uploading={uploadingStates.leftBottom}
                              onUpload={() => handleUpload(leftBottomMedia, 'leftBottom')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.leftBottom} />
                          </div>
                        </div>

                        {/* Right Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.rightBottom?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Right Bottom Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.rightBottom.enabled}
                              onChange={val => handleToggleChangeMedia('rightBottom', val)}
                              id={'rightBottom'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setRightBottomMedia)}
                              selectedFile={rightBottomMedia}
                            />
                            <UploadButton
                              uploading={uploadingStates.rightBottom}
                              onUpload={() => handleUpload(rightBottomMedia, 'rightBottom')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.rightBottom} />
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        {/* Correct Animation Audio */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.correctResponse?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Correct Animation Audio:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.correctResponse.enabled}
                              id={'correctResponse'}
                              onChange={value => handleToggleChangeMedia('correctResponse', value)}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setCorrectResponse)}
                              selectedFile={correctResponse}
                            />

                            <UploadButton
                              uploading={uploadingStates.correctResponse}
                              onUpload={() => handleUpload(correctResponse, 'correctResponse')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.correctResponse} />
                          </div>
                        </div>

                        {/* Correct Animation Gif */}

                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.correctResponseGif?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Correct Animation Gif:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.correctResponseGif.enabled}
                              id={'correctResponseGif'}
                              onChange={value =>
                                handleToggleChangeMedia('correctResponseGif', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setCorrectResponseGif)}
                              selectedFile={correctResponseGif}
                            />

                            <UploadButton
                              uploading={uploadingStates.correctResponseGif}
                              onUpload={() =>
                                handleUpload(correctResponseGif, 'correctResponseGif')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.correctResponseGif} />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* Wrong Animation Audio */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.wrongResponse?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Wrong Animation Audio:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.wrongResponse.enabled}
                              onChange={val => handleToggleChangeMedia('wrongResponse', val)}
                              id={'wrongResponse'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setWrongResponse)}
                              selectedFile={wrongResponse}
                            />
                            <UploadButton
                              uploading={uploadingStates.wrongResponse}
                              onUpload={() => handleUpload(wrongResponse, 'wrongResponse')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.wrongResponse} />
                          </div>
                        </div>

                        {/* Wrong Animation Gif */}

                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.wrongResponseGif?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Wrong Animation Gif:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.wrongResponseGif.enabled}
                              onChange={val => handleToggleChangeMedia('wrongResponseGif', val)}
                              id={'wrongResponseGif'}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setWrongResponseGif)}
                              selectedFile={wrongResponseGif}
                            />
                            <UploadButton
                              uploading={uploadingStates.wrongResponseGif}
                              onUpload={() => handleUpload(wrongResponseGif, 'wrongResponseGif')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.wrongResponseGif} />
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        {/* Left Bottom Media */}
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.promoPageVideo?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Promo Page Video :</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.promoPageVideo.enabled}
                              id={'promoPageVideo'}
                              onChange={value => handleToggleChangeMedia('promoPageVideo', value)}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setPromoPageVideo)}
                              selectedFile={promoPageVideo}
                            />
                            <UploadButton
                              uploading={uploadingStates.promoPageVideo}
                              onUpload={() => handleUpload(promoPageVideo, 'promoPageVideo')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.promoPageVideo} />
                          </div>
                        </div>

                        {/* Right Bottom Media */}

                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.questionTimerVideo?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Question Timer Video :</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.questionTimerVideo.enabled}
                              id={'questionTimerVideo'}
                              onChange={value =>
                                handleToggleChangeMedia('questionTimerVideo', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setQuestionTimerVideo)}
                              selectedFile={questionTimerVideo}
                            />
                            <UploadButton
                              uploading={uploadingStates.questionTimerVideo}
                              onUpload={() =>
                                handleUpload(questionTimerVideo, 'questionTimerVideo')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.questionTimerVideo} />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.promoPageCenterLogo?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Result Page Center Logo:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.promoPageCenterLogo.enabled}
                              id={'promoPageCenterLogo'}
                              onChange={value =>
                                handleToggleChangeMedia('promoPageCenterLogo', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setPromoPageCenterLogo)}
                              selectedFile={promoPageCenterLogo}
                            />
                            <UploadButton
                              uploading={uploadingStates.promoPageCenterLogo}
                              onUpload={() =>
                                handleUpload(promoPageCenterLogo, 'promoPageCenterLogo')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.promoPageCenterLogo} />
                          </div>
                        </div>

                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.promoPageCenterBelowLogo?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Result Page Center Below Logo:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.promoPageCenterBelowLogo.enabled}
                              id={'promoPageCenterBelowLogo'}
                              onChange={value =>
                                handleToggleChangeMedia('promoPageCenterBelowLogo', value)
                              }
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setPromoPageCenterBelowLogo)}
                              selectedFile={promoPageCenterBelowLogo}
                            />
                            <UploadButton
                              uploading={uploadingStates.promoPageCenterBelowLogo}
                              onUpload={() =>
                                handleUpload(promoPageCenterBelowLogo, 'promoPageCenterBelowLogo')
                              }
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.promoPageCenterBelowLogo} />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <div
                            className={`form-group menu-card2 ${!uploadedUrls?.resultBackMedia?.enabled ? 'disabled' : ''}`}
                          >
                            <label>Result Page Back Media:</label>
                            <ToggleSwitch
                              label="Enable"
                              isOn={uploadedUrls.resultBackMedia.enabled}
                              id={'resultBackMedia'}
                              onChange={value => handleToggleChangeMedia('resultBackMedia', value)}
                            />
                            <MediaDropzone
                              onDrop={createDropHandler(setResultBackMedia)}
                              selectedFile={resultBackMedia}
                            />
                            <UploadButton
                              uploading={uploadingStates.resultBackMedia}
                              onUpload={() => handleUpload(resultBackMedia, 'resultBackMedia')}
                              buttonColor={buttonColor}
                            />
                            <UploadedUrl url={uploadedUrls.resultBackMedia} />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Height Offset From Top in % :</label>
                            <input
                              type="number"
                              value={heightoffset}
                              onChange={e => setHeightOffset(Number(e.target.value))}
                              placeholder="Enter Height Offset From Top"
                              className="form-control"
                            />
                          </div>
                          <div className="form-group menu-card2">
                            <label>Left Offset % :</label>
                            <input
                              type="number"
                              value={leftoffset}
                              onChange={e => setLeftOffset(Number(e.target.value))}
                              placeholder="Enter Left Offset"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Enter a second for result page to Promo Page:</label>
                            <input
                              type="number"
                              value={resultToPromo}
                              onChange={e => setResultToPromo(Number(e.target.value))}
                              placeholder="Enter a second for result page to Promo Page"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Right Offset % :</label>
                            <input
                              type="number"
                              value={rightOffset}
                              onChange={e => setRightOffset(Number(e.target.value))}
                              placeholder="Enter Left Offset"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Quiz Page Popup Font Size In Px</label>
                            <input
                              type="number"
                              value={quizFontSize}
                              onChange={e => setQuizFontSize(Number(e.target.value))}
                              placeholder="Quiz Page Popup Font Size In Px"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Topic Page Popup Padding In Px</label>
                            <input
                              type="number"
                              value={quizPadding}
                              onChange={e => setQuizPadding(Number(e.target.value))}
                              placeholder="Topic Page Popup Padding In Px"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group menu-card2">
                            <label>Quiz Page Popup Font lineHeight</label>
                            <input
                              type="number"
                              value={quizLineHeight}
                              onChange={e => setQuizLineHeight(Number(e.target.value))}
                              placeholder="Quiz Page Popup Font lineHeight"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <button
                            style={{ backgroundColor: buttonColor }}
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}

                {value === 3 && (
                  <>
                    <div className="row" style={{ marginBottom: '40px', marginTop: '30px' }}>
                      <div className="col-md-12 d-flex justify-content-center">
                        <div className="form-group">
                          <Button
                            key={userId}
                            text={'Sample Button'}
                            settings={settings?.globalSettings}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="global-section">
                      {/* Global Settings */}

                      <form
                        className="tab-wizard wizard-circle wizard vertical"
                        onSubmit={handleSubmit}
                      >
                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Font Line Height:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={
                                  settings.enabled
                                    ? (settings?.globalSettings?.lineHeight ?? 1)
                                    : (settings?.globalSettings?.lineHeight ?? 1)
                                }
                                onChange={e => handleChange('lineHeight', Number(e.target.value))}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Padding:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={
                                  settings.enabled
                                    ? (settings?.globalSettings?.padding ?? 10)
                                    : (settings?.globalSettings?.padding ?? 10)
                                }
                                onChange={e => handleChange('padding', Number(e.target.value))}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Margin Bottom:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={
                                  settings.enabled
                                    ? (settings?.globalSettings?.marginBottom ?? 0)
                                    : (settings?.globalSettings?.marginBottom ?? 0)
                                }
                                onChange={e => handleChange('marginBottom', Number(e.target.value))}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Corner Radius:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={settings?.globalSettings?.cornerRadius ?? 0}
                                onChange={e => handleChange('cornerRadius', Number(e.target.value))}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Height:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.height ?? 0}
                                onChange={e => handleChange('height', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Width:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.width ?? 0}
                                onChange={e => handleChange('width', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>

                          {/* <div className="col-md-3">
            <div className="form-group">
              <label>Margin Bottom:</label>
                <input
                  type="number"
                  className="form-control"
                  value={                    
                    settings?.globalSettings?.marginBottom ?? 0
                  }
                  onChange={(e) => handleChange('marginBottom', Number(e.target.value))}
                />  
            </div>
        </div>   */}
                        </div>

                        {/* Outline */}

                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Outline color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={settings?.globalSettings?.outlineColor === 'transparent'}
                                  onChange={e =>
                                    handleChange(
                                      'outlineColor',
                                      e.target.checked ? 'transparent' : '#000000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control mt-1"
                                format="hex"
                                value={settings?.globalSettings?.outlineColor || '#000000'}
                                onChange={newHex =>
                                  handleChange('outlineColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={settings?.globalSettings?.outlineColor === 'transparent'} // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control mt-1"
                                disabled={settings?.globalSettings?.outlineColor === "transparent"} // Disable when transparent
                                value={

                                  settings?.globalSettings?.outlineColor || "#000000"
                                }
                                onChange={(e) => handleChange("outlineColor", e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Outline Thickness:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.outlineThickness ?? 0}
                                onChange={e =>
                                  handleChange('outlineThickness', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Text Alignment (left centre or right):</label>

                              <select
                                id="textAlign"
                                value={settings?.globalSettings?.textAlign || 'left'}
                                onChange={e => handleChange('textAlign', e.target.value)}
                                className="form-select form-control"
                              >
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Fill Color */}
                        <div className="row menu-card2">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Fill color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={settings?.globalSettings?.fillColor === 'transparent'}
                                  onChange={e =>
                                    handleChange(
                                      'fillColor',
                                      e.target.checked ? 'transparent' : '#000000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={settings?.globalSettings?.fillColor || '#000000'}
                                onChange={newHex =>
                                  handleChange('fillColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={settings?.globalSettings?.fillColor === 'transparent'} // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={settings?.globalSettings?.fillColor === "transparent"} // Disable when transparent

                                value={
                                  settings?.globalSettings?.fillColor || "#000000"
                                }
                                onChange={(e) => handleChange('fillColor', e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Font Family:</label>

                              <select
                                id="font"
                                value={settings?.globalSettings?.font || 'Arial'}
                                onChange={e => handleChange('font', e.target.value)}
                                className="form-select form-control"
                              >
                                {fontOptions}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Font color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={settings?.globalSettings?.fontColor === 'transparent'}
                                  onChange={e =>
                                    handleChange(
                                      'fontColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={settings?.globalSettings?.fontColor || '#000000'}
                                onChange={newHex =>
                                  handleChange('fontColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={settings?.globalSettings?.fontColor === 'transparent'} // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={settings?.globalSettings?.fontColor === "transparent"} // Disable when transparent

                                value={

                                  settings?.globalSettings?.fontColor || "#000000"
                                }
                                onChange={(e) => handleChange('fontColor', e.target.value)}
                                className="form-control"
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Font Size:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.fontSize || ''}
                                onChange={e => handleChange('fontSize', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Shadow Settings */}

                        <div className="row menu-card2">
                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow angle:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={settings?.globalSettings?.shadow?.angle ?? 0}
                                onChange={e => handleChange('shadow.angle', Number(e.target.value))}
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow size:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.shadow?.size ?? 0}
                                onChange={e => handleChange('shadow.size', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow distance:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.shadow?.distance ?? 0}
                                onChange={e =>
                                  handleChange('shadow.distance', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow Alpha:</label>
                              <input
                                type="number"
                                value={settings?.globalSettings?.shadow?.alpha ?? 0}
                                onChange={e => handleChange('shadow.alpha', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Shadow color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    settings?.globalSettings?.shadow?.color === 'transparent'
                                  }
                                  onChange={e =>
                                    handleChange(
                                      'shadow.color',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={settings?.globalSettings?.shadow?.color || '#000000'}
                                onChange={newHex =>
                                  handleChange('shadow.color', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={settings?.globalSettings?.shadow?.color === 'transparent'} // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={settings?.globalSettings?.shadow?.color === "transparent"} // Disable when transparent

                                value={
                                  settings?.globalSettings?.shadow?.color || "#000000"
                                }
                                onChange={(e) => handleChange('shadow.color', e.target.value)}
                                className="form-control"
                              /> */}
                            </div>
                          </div>
                        </div>

                        {/* Highlight */}

                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight boarder color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    settings?.globalSettings?.highlight?.borderColor ===
                                    'transparent'
                                  }
                                  onChange={e =>
                                    handleChange(
                                      'highlight.borderColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  settings?.globalSettings?.highlight?.borderColor || '#000000'
                                }
                                onChange={newHex =>
                                  handleChange('highlight.borderColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  settings?.globalSettings?.highlight?.borderColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={settings?.globalSettings?.highlight?.borderColor === "transparent"} // Disable when transparent

                                value={
                                  settings?.globalSettings?.highlight?.borderColor || "#000000"
                                }
                                onChange={(e) => handleChange('highlight.borderColor', e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight fills color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    settings?.globalSettings?.highlight?.fillColor === 'transparent'
                                  }
                                  onChange={e =>
                                    handleChange(
                                      'highlight.fillColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={settings?.globalSettings?.highlight?.fillColor || '#000000'}
                                onChange={newHex =>
                                  handleChange('highlight.fillColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  settings?.globalSettings?.highlight?.fillColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={settings?.globalSettings?.highlight?.fillColor === "transparent"} // Disable when transparent
                                className="form-control"
                                value={
                                  settings?.globalSettings?.highlight?.fillColor || "#000000"
                                }
                                onChange={(e) => handleChange('highlight.fillColor', e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight Font color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    settings?.globalSettings?.highlight?.fontColor === 'transparent'
                                  }
                                  onChange={e =>
                                    handleChange(
                                      'highlight.fontColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={settings?.globalSettings?.highlight?.fontColor || '#000000'}
                                onChange={newHex =>
                                  handleChange('highlight.fontColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  settings?.globalSettings?.highlight?.fontColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={settings?.globalSettings?.highlight?.fontColor === "transparent"} // Disable when transparent
                                value={
                                  settings?.globalSettings?.highlight?.fontColor || "#000000"
                                }
                                onChange={(e) => handleChange('highlight.fontColor', e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>

                        {/* click Sound */}

                        <button style={{ backgroundColor: buttonColor }} type="submit">
                          Save Settings
                        </button>
                      </form>
                    </div>
                  </>
                )}

                {value === 4 && (
                  <>
                    <div className="row" style={{ marginBottom: '40px', marginTop: '30px' }}>
                      <div className="col-md-12 d-flex justify-content-center">
                        <div className="form-group">
                          <Button
                            key={userId}
                            text={'Sample Button'}
                            settings={answerSettings?.answerSettings}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="global-section">
                      {/* Global Settings */}

                      <form
                        className="tab-wizard wizard-circle wizard vertical"
                        onSubmit={handleSubmit}
                      >
                        <div className="row menu-card2">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Corner Radius:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={answerSettings?.answerSettings?.cornerRadius ?? 0}
                                onChange={e =>
                                  handleAnswerChange('cornerRadius', Number(e.target.value))
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Height:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.height ?? 0}
                                onChange={e => handleAnswerChange('height', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Width:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.width ?? 0}
                                onChange={e => handleAnswerChange('width', Number(e.target.value))}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Margin Bottom:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={answerSettings?.answerSettings?.marginBottom ?? 0}
                                onChange={e =>
                                  handleAnswerChange('marginBottom', Number(e.target.value))
                                }
                              />
                            </div>
                          </div>
                        </div>

                        {/* Outline */}

                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Outline color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.outlineColor === 'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'outlineColor',
                                      e.target.checked ? 'transparent' : '#000000'
                                    )
                                  }
                                />
                                )
                              </label>
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={answerSettings?.answerSettings?.outlineColor || '#000000'}
                                onChange={newHex =>
                                  handleAnswerChange('outlineColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.outlineColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control mt-1"
                                disabled={answerSettings?.answerSettings?.outlineColor === "transparent"} // Disable when transparent
                                value={

                                  answerSettings?.answerSettings?.outlineColor || "#000000"
                                }
                                onChange={(e) => handleAnswerChange("outlineColor", e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Outline Thickness:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.outlineThickness ?? 0}
                                onChange={e =>
                                  handleAnswerChange('outlineThickness', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Text Alignment (left centre or right):</label>

                              <select
                                id="textAlign"
                                value={answerSettings?.answerSettings?.textAlign || 'left'}
                                onChange={e => handleAnswerChange('textAlign', e.target.value)}
                                className="form-select form-control"
                              >
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Fill Color */}
                        <div className="row menu-card2">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Fill color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.fillColor === 'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'fillColor',
                                      e.target.checked ? 'transparent' : '#000000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={answerSettings?.answerSettings?.fillColor || '#000000'}
                                onChange={newHex =>
                                  handleAnswerChange('fillColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.fillColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={answerSettings?.answerSettings?.fillColor === "transparent"} // Disable when transparent

                                value={
                                  answerSettings?.answerSettings?.fillColor || "#000000"
                                }
                                onChange={(e) => handleAnswerChange('fillColor', e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Font Family:</label>

                              <select
                                id="font"
                                value={answerSettings?.answerSettings?.font || 'Arial'}
                                onChange={e => handleAnswerChange('font', e.target.value)}
                                className="form-select form-control"
                              >
                                {fontOptions}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Font color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.fontColor === 'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'fontColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={answerSettings?.answerSettings?.fontColor || '#000000'}
                                onChange={newHex =>
                                  handleAnswerChange('fontColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.fontColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={answerSettings?.answerSettings?.fontColor === "transparent"} // Disable when transparent

                                value={

                                  answerSettings?.answerSettings?.fontColor || "#000000"
                                }
                                onChange={(e) => handleAnswerChange('fontColor', e.target.value)}
                                className="form-control"
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Font Size:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.fontSize || ''}
                                onChange={e =>
                                  handleAnswerChange('fontSize', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Shadow Settings */}

                        <div className="row menu-card2">
                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow angle:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={answerSettings?.answerSettings?.shadow?.angle ?? 0}
                                onChange={e =>
                                  handleAnswerChange('shadow.angle', Number(e.target.value))
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow size:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.shadow?.size ?? 0}
                                onChange={e =>
                                  handleAnswerChange('shadow.size', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow distance:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.shadow?.distance ?? 0}
                                onChange={e =>
                                  handleAnswerChange('shadow.distance', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Shadow Alpha:</label>
                              <input
                                type="number"
                                value={answerSettings?.answerSettings?.shadow?.alpha ?? 0}
                                onChange={e =>
                                  handleAnswerChange('shadow.alpha', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Shadow color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.shadow?.color === 'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'shadow.color',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={answerSettings?.answerSettings?.shadow?.color || '#000000'}
                                onChange={newHex =>
                                  handleAnswerChange('shadow.color', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.shadow?.color === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={answerSettings?.answerSettings?.shadow?.color === "transparent"} // Disable when transparent

                                value={
                                  answerSettings?.answerSettings?.shadow?.color || "#000000"
                                }
                                onChange={(e) => handleAnswerChange('shadow.color', e.target.value)}
                                className="form-control"
                              /> */}
                            </div>
                          </div>
                        </div>

                        {/* Highlight */}

                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight boarder color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.highlight?.borderColor ===
                                    'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'highlight.borderColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  answerSettings?.answerSettings?.highlight?.borderColor ||
                                  '#000000'
                                }
                                onChange={newHex =>
                                  handleAnswerChange(
                                    'highlight.borderColor',
                                    newHex?.toUpperCase?.()
                                  )
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.highlight?.borderColor ===
                                  'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={answerSettings?.answerSettings?.highlight?.borderColor === "transparent"} // Disable when transparent

                                value={
                                  answerSettings?.answerSettings?.highlight?.borderColor || "#000000"
                                }
                                onChange={(e) => handleAnswerChange('highlight.borderColor', e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight fills color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.highlight?.fillColor ===
                                    'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'highlight.fillColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  answerSettings?.answerSettings?.highlight?.fillColor || '#000000'
                                }
                                onChange={newHex =>
                                  handleAnswerChange('highlight.fillColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.highlight?.fillColor ===
                                  'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={answerSettings?.answerSettings?.highlight?.fillColor === "transparent"} // Disable when transparent
                                className="form-control"
                                value={
                                  answerSettings?.answerSettings?.highlight?.fillColor || "#000000"
                                }
                                onChange={(e) => handleAnswerChange('highlight.fillColor', e.target.value)}
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight Font color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    answerSettings?.answerSettings?.highlight?.fontColor ===
                                    'transparent'
                                  }
                                  onChange={e =>
                                    handleAnswerChange(
                                      'highlight.fontColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>
                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  answerSettings?.answerSettings?.highlight?.fontColor || '#000000'
                                }
                                onChange={newHex =>
                                  handleAnswerChange('highlight.fontColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  answerSettings?.answerSettings?.highlight?.fontColor ===
                                  'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={answerSettings?.answerSettings?.highlight?.fontColor === "transparent"} // Disable when transparent
                                value={
                                  answerSettings?.answerSettings?.highlight?.fontColor || "#000000"
                                }
                                onChange={(e) => handleAnswerChange('highlight.fontColor', e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>

                        {/* click Sound */}

                        <button style={{ backgroundColor: buttonColor }} type="submit">
                          Save Settings
                        </button>
                      </form>
                    </div>
                  </>
                )}

                {value === 5 && (
                  <>
                    <div className="row" style={{ marginBottom: '40px', marginTop: '30px' }}>
                      <div className="col-md-12">
                        <div className="col-md-12 d-flex justify-content-center">
                          <SplashText
                            text={'Question Text'}
                            settings={questionTextSettings?.questionTextSettings}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="global-section">
                      {/* Global Settings */}

                      <form
                        className="tab-wizard wizard-circle wizard vertical"
                        onSubmit={handleSubmit}
                      >
                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Height:</label>
                              <input
                                type="number"
                                value={questionTextSettings?.questionTextSettings?.height ?? 0}
                                onChange={e =>
                                  handleQuestionTextChange('height', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Width %:</label>
                              <input
                                type="number"
                                value={questionTextSettings?.questionTextSettings?.width ?? 0}
                                onChange={e =>
                                  handleQuestionTextChange('width', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Text Alignment (left centre or right):</label>

                              <select
                                id="textAlign"
                                value={
                                  questionTextSettings?.questionTextSettings?.textAlign || 'left'
                                }
                                onChange={e =>
                                  handleQuestionTextChange('textAlign', e.target.value)
                                }
                                className="form-select form-control"
                              >
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Fill Color */}
                        <div className="row menu-card2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Font Family:</label>

                              <select
                                id="font"
                                value={questionTextSettings?.questionTextSettings?.font || 'Arial'}
                                onChange={e => handleQuestionTextChange('font', e.target.value)}
                                className="form-select form-control"
                              >
                                {fontOptions}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Font color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    questionTextSettings?.questionTextSettings?.fontColor ===
                                    'transparent'
                                  }
                                  onChange={e =>
                                    handleQuestionTextChange(
                                      'fontColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  questionTextSettings?.questionTextSettings?.fontColor || '#000000'
                                }
                                onChange={newHex =>
                                  handleQuestionTextChange('fontColor', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  questionTextSettings?.questionTextSettings?.fontColor ===
                                  'transparent'
                                }
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={questionTextSettings?.questionTextSettings?.fontColor === "transparent"}
                                value={
                                  questionTextSettings?.questionTextSettings?.fontColor || "#000000"
                                }
                                onChange={(e) => handleQuestionTextChange('fontColor', e.target.value)}
                                className="form-control"
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Font Size:</label>
                              <input
                                type="number"
                                value={questionTextSettings?.questionTextSettings?.fontSize || ''}
                                onChange={e =>
                                  handleQuestionTextChange('fontSize', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Shadow Settings */}

                        <div className="row menu-card2">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Shadow angle:</label>
                              <input
                                type="number"
                                className="form-control"
                                value={
                                  questionTextSettings?.questionTextSettings?.shadow?.angle ?? 0
                                }
                                onChange={e =>
                                  handleQuestionTextChange('shadow.angle', Number(e.target.value))
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Shadow size:</label>
                              <input
                                type="number"
                                value={
                                  questionTextSettings?.questionTextSettings?.shadow?.size ?? 0
                                }
                                onChange={e =>
                                  handleQuestionTextChange('shadow.size', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Shadow distance:</label>
                              <input
                                type="number"
                                value={
                                  questionTextSettings?.questionTextSettings?.shadow?.distance ?? 0
                                }
                                onChange={e =>
                                  handleQuestionTextChange(
                                    'shadow.distance',
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Shadow Alpha:</label>
                              <input
                                type="number"
                                value={
                                  questionTextSettings?.questionTextSettings?.shadow?.alpha ?? 0
                                }
                                onChange={e =>
                                  handleQuestionTextChange('shadow.alpha', Number(e.target.value))
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row menu-card2">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Shadow color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    questionTextSettings?.questionTextSettings?.shadow?.color ===
                                    'transparent'
                                  }
                                  onChange={e =>
                                    handleQuestionTextChange(
                                      'shadow.color',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  questionTextSettings?.questionTextSettings?.shadow?.color ||
                                  '#000000'
                                }
                                onChange={newHex =>
                                  handleQuestionTextChange('shadow.color', newHex?.toUpperCase?.())
                                }
                                fallbackValue="#000000"
                                disabled={
                                  questionTextSettings?.questionTextSettings?.shadow?.color ===
                                  'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                disabled={questionTextSettings?.questionTextSettings?.shadow?.color === "transparent"} // Disable when transparent
                                value={
                                  questionTextSettings?.questionTextSettings?.shadow?.color || "#000000"
                                }
                                onChange={(e) => handleQuestionTextChange('shadow.color', e.target.value)}
                                className="form-control"
                              /> */}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label
                                className="d-flex align-items-center"
                                style={{ height: '25px' }}
                              >
                                Highlight Font color: (Transparent
                                <input
                                  type="checkbox"
                                  className="ml-1 mr-1"
                                  checked={
                                    questionTextSettings?.questionTextSettings?.highlight
                                      ?.fontColor === 'transparent'
                                  }
                                  onChange={e =>
                                    handleQuestionTextChange(
                                      'highlight.fontColor',
                                      e.target.checked ? 'transparent' : '#00000'
                                    )
                                  }
                                />
                                )
                              </label>

                              <MuiColorInput
                                className="form-control"
                                format="hex"
                                value={
                                  questionTextSettings?.questionTextSettings?.highlight
                                    ?.fontColor || '#000000'
                                }
                                onChange={newHex =>
                                  handleQuestionTextChange(
                                    'highlight.fontColor',
                                    newHex?.toUpperCase?.()
                                  )
                                }
                                fallbackValue="#000000"
                                disabled={
                                  questionTextSettings?.questionTextSettings?.highlight
                                    ?.fontColor === 'transparent'
                                } // Disable when transparent
                                // size="small"
                                isAlphaHidden={true} // This disables the alpha slider
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '0px !important',
                                    height: 53,
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    height: '36px',
                                  },
                                  '& .MuiColorInput-Button': {
                                    width: '49px !important', // Increase width
                                    height: '40px !important',
                                  },
                                  '& .MuiInputAdornment-root .MuiBox-root': {
                                    width: 18,
                                    height: 18,
                                  },
                                }}
                              />

                              {/* <input
                                type="color"
                                className="form-control"
                                disabled={questionTextSettings?.questionTextSettings?.highlight?.fontColor === "transparent"} // Disable when transparent
                                value={
                                  questionTextSettings?.questionTextSettings?.highlight?.fontColor || "#000000"
                                }
                                onChange={(e) => handleQuestionTextChange('highlight.fontColor', e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <button
                              style={{ backgroundColor: buttonColor }}
                              type="submit"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </>
                )}

                {value === 6 && (
                  <div>
                    <LanguageSelector userId={userId} buttonColor={buttonColor} />
                  </div>
                )}
              </Box>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}

// Helper function to get language name
const getLanguageName = (code) => {
  const languageNames = {
    'en': 'English',
    'es': 'Spanish',
    'fr': 'French',
    'de': 'German',
    'it': 'Italian',
    'pt': 'Portuguese',
    'ru': 'Russian',
    'zh': 'Chinese',
    'ja': 'Japanese',
    'ko': 'Korean',
    'ar': 'Arabic',
    'hi': 'Hindi',
    'tr': 'Turkish',
    'nl': 'Dutch',
    'sv': 'Swedish',
    'pl': 'Polish',
    'th': 'Thai',
    'vi': 'Vietnamese',
    'id': 'Indonesian'
  };
  return languageNames[code] || code.toUpperCase();
};

// Helper function to get language flag code
const getLanguageFlag = (code) => {
  const flagMap = {
    'en': 'us',
    'es': 'es',
    'fr': 'fr',
    'de': 'de',
    'it': 'it',
    'pt': 'pt',
    'ru': 'ru',
    'zh': 'cn',
    'ja': 'jp',
    'ko': 'kr',
    'ar': 'sa',
    'hi': 'in',
    'tr': 'tr',
    'nl': 'nl',
    'sv': 'se',
    'pl': 'pl',
    'th': 'th',
    'vi': 'vn',
    'id': 'id'
  };
  return flagMap[code] || 'xx'; // 'xx' is a generic flag
};

// MediaDropzone Component
const MediaDropzone = ({ onDrop, selectedFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif'],
      'video/*': ['.mp4', '.mov', '.mp3'],
      'application/pdf': ['.pdf'],
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #cccccc',
        padding: '20px',
        borderRadius: '5px',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <input {...getInputProps()} />
      {selectedFile ? (
        <p>{selectedFile.name}</p>
      ) : (
        <p>Drag and drop a file here, or click to select a file</p>
      )}
    </div>
  );
};

// Helper function to check if the file is an image
const getFileType = fileUrl => {
  if (!fileUrl) return 'blank'; // No URL provided

  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
  const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];

  if (imageExtensions.some(ext => fileUrl.toLowerCase().endsWith(ext))) {
    return 'image';
  }
  if (videoExtensions.some(ext => fileUrl.toLowerCase().endsWith(ext))) {
    return 'video';
  }
  return 'other'; // Other file types or unsupported extensions
};

// UploadButton Component
const UploadButton = ({ uploading, onUpload, buttonColor }) => (
  <button
    onClick={onUpload}
    type="button"
    style={{
      marginTop: '20px',
      //   padding: "10px 20px",
      backgroundColor: buttonColor,
      // color: "#FFFFFF",
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    }}
    disabled={uploading}
  >
    {uploading ? 'Uploading...' : 'Upload'}
  </button>
);

// UploadedUrl Component
const UploadedUrl = ({ url }) =>
  url ? (
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start', // Adjust alignment of child elements (optional)
        gap: '10px', // Add spacing between child elements (optional)
      }}
    >
      <div style={{ float: 'left', width: '70%', marginTop: '15px' }}>
        Uploaded File:{' '}
        <a
          href={url.fileUrl}
          style={{ fontWeight: 'bold' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url.fileName}
        </a>
      </div>
      <div style={{ float: 'right', width: '30%', textAlign: 'right' }}>
        {getFileType(url.fileUrl) === 'image' ? (
          // Render image if it's an image file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img src={url.fileUrl} style={{ maxWidth: '200px', maxHeight: '60px' }} alt="" />
          </a>
        ) : getFileType(url.fileUrl) === 'video' ? (
          // Render play button for video file
          <a href={url.fileUrl} target="_blank" rel="noreferrer">
            <img
              src="https://paulavatar.s3.us-east-2.amazonaws.com/play-button.png"
              style={{ maxWidth: '200px', maxHeight: '60px' }}
              alt="Play Video"
            />
          </a>
        ) : (
          // Fallback for other cases
          ''
        )}
      </div>
    </div>
  ) : null;
